import { rubberbandIfOutOfBounds } from '@use-gesture/react';
import { getCurrentRef } from '@vista-digital/react-tools';
import { useMotionValue } from 'framer-motion';
export function useScaleControls(options) {
    const { initial, min, max, contentDimensions, contentRef } = options;
    const scale = useMotionValue(initial);
    const minScale = useMotionValue(min);
    const maxScale = useMotionValue(max);
    const getContentElement = () => {
        return getCurrentRef(contentRef);
    };
    const setScale = (newScale) => {
        // Store the scale prior to damping
        scale.set(newScale);
        // Apply the post-damping scale to the content
        const displayedScale = rubberbandIfOutOfBounds(newScale, minScale.get(), maxScale.get(), 0.15);
        const content = getContentElement();
        content.style.width = `${contentDimensions.width * displayedScale}px`;
        content.style.height = `${contentDimensions.height * displayedScale}px`;
        return displayedScale;
    };
    return {
        scale,
        minScale,
        maxScale,
        setScale,
        setMinScale: (newMin) => {
            minScale.set(newMin);
            // If the current scale is less than the new minimum scale, set the current scale to the new minimum scale.
            if (scale.get() < newMin) {
                scale.set(newMin);
            }
        }
    };
}
//# sourceMappingURL=use-scale-controls.js.map